import React, { useState } from "react";
import DrawerFilter from "../../../components/listing/DrawerFilter";
import InputNumberNoScroll from "../../../components/inputs/inputNumberNoScroll";

export default function FiltroAuditoria({
  initialFilters = {},
  onSubmit = () => {},
  onClose = () => {},
}) {
  // ===========================
  // 1. ESTADOS (Mapeo 1:1 con DTO)
  // ===========================
  // Nota: dataFecha es Date, pero el input type="date" usa string YYYY-MM-DD
  const [fecha, setFecha] = useState(initialFilters.dataFecha || "");
  const [usuario, setUsuario] = useState(initialFilters.descricaoUsuario || "");
  const [tarea, setTarea] = useState(initialFilters.descricaoTarea || "");
  const [origen, setOrigen] = useState(initialFilters.descricaoOrigen || "");
  const [tabla, setTabla] = useState(initialFilters.codigoTabla || "");
  const [sqCod, setSqCod] = useState(initialFilters.codigoSqCod || "");
  const [operacion, setOperacion] = useState(initialFilters.codigoTipo || "");

  const [isLoading, setIsLoading] = useState(false);

// ===========================
  // 2. LISTAS ESTÁTICAS (Enum)
  // ===========================
  // Los IDs deben coincidir con el NOMBRE del Enum en Java, no con su valor interno.
  const listaOperaciones = [
    { id: "INSERCION", nombre: "INSERCION" },      // Antes "I"
    { id: "ACTUALIZACION", nombre: "ACTUALIZACION" }, // Antes "U"
    { id: "ELIMINACION", nombre: "ELIMINACION" },  // Antes "D"
    { id: "CONSULTA", nombre: "CONSULTA" },        // Antes "C"
  ];

  // ===========================
  // 3. HANDLERS
  // ===========================
  const handleApply = async () => {
    setIsLoading(true);
    
    // Construimos el objeto de filtros
    // Filtramos strings vacíos para no enviar basura
    const filtrosAplicados = {
      dataFecha: fecha || null,
      descricaoUsuario: usuario.trim() || null,
      descricaoTarea: tarea.trim() || null,
      descricaoOrigen: origen.trim() || null,
      codigoTabla: tabla.trim() || null,
      codigoSqCod: sqCod.trim() || null,
      codigoTipo: operacion || null,
    };

    // Simulamos un pequeño delay visual (opcional) o validaciones
    // await new Promise(r => setTimeout(r, 200));

    onSubmit(filtrosAplicados);
    setIsLoading(false);
    onClose(); // Cerramos el drawer al aplicar
  };

  // ===========================
  // 4. RENDER
  // ===========================
  return (
    <DrawerFilter
      title="Filtros de Auditoría"
      onClose={onClose}
      onApply={handleApply}
      isLoading={isLoading}
    >
      {/* --- 1. FECHA --- */}
      <div>
        <label className="form-label-fil">Fecha:</label>
        <input
          type="date"
          className="input mt-1 w-full"
          value={fecha}
          onChange={(e) => setFecha(e.target.value)}
        />
      </div>

      {/* --- 4. TAREA --- */}
      <div>
        <label className="form-label-fil">Tarea:</label>
        <textarea
          placeholder="Buscar en descripción..."
          className="mt-1 w-full resize-y border border-gray-300 rounded-md p-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 text-sm"
          rows={3}
          value={tarea}
          onChange={(e) => setTarea(e.target.value)}
        />
      </div>

      {/* --- 3. USUARIO --- */}
      <div>
        <label className="form-label-fil">Usuario:</label>
        <input
          type="text"
          placeholder="Ej: admin"
          className="input mt-1 w-full"
          value={usuario}
          onChange={(e) => setUsuario(e.target.value)}
        />
      </div>

      {/* --- 4. TABLA --- */}
      <div>
        <label className="form-label-fil">Tabla:</label>
        <input
          type="text"
          placeholder="Ej: USUARIO"
          className="input mt-1 w-full"
          value={tabla}
          onChange={(e) => setTabla(e.target.value)}
        />
      </div>

      {/* --- 5. CÓDIGO de Auditoría --- */}
      <div>
        <label className="form-label-fil">Código de Auditoría:</label>
        <InputNumberNoScroll
          placeholder="ID de Auditoría"
          className="input mt-1 w-full"
          value={sqCod}
          onChange={(e) => setSqCod(e.target.value)}
        />
      </div>

      {/* --- 6. OPERACIÓN --- */}
      <div>
        <label className="form-label-fil">Operación:</label>
        <select
          className="input mt-1 w-full"
          value={operacion}
          onChange={(e) => setOperacion(e.target.value)}
        >
          <option value="">-- Todas --</option>
          {listaOperaciones.map((op) => (
            <option key={op.id} value={op.id}>
              {op.nombre}
            </option>
          ))}
        </select>
      </div>

    </DrawerFilter>
  );
}